import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useState,
  useCallback,
} from 'react';
import TuModal from '@components/transunion-flow/tu-modal';

import { TuStep } from './tu-modal-stepper';

export interface SetShowTuStepperParams {
  show: boolean;
  tuStep?: TuStep;
}

interface Props {
  tuVisibility: SetShowTuStepperParams;
  setTuVisibility: (props: SetShowTuStepperParams) => void;
  handleOnSuccess?: () => void;
}

export const TuVisibilityContext =
  createContext<Omit<Props, 'handleOnSuccess'>>(undefined);

interface TuVisibilityProviderProps {
  onLinkTransunionSuccess?: () => void;
}

const TuVisibilityProvider: React.FC<
  PropsWithChildren<TuVisibilityProviderProps>
> = ({ children, onLinkTransunionSuccess }) => {
  const [tuVisibility, setTuVisibility] = useState<SetShowTuStepperParams>({
    show: false,
  });

  const handleOnSuccess = useCallback(() => {
    onLinkTransunionSuccess?.();
    window.dispatchEvent(new Event('onLinkTransunionSuccess'));
  }, [onLinkTransunionSuccess]);

  return (
    <TuVisibilityContext.Provider
      value={{
        tuVisibility,
        setTuVisibility,
      }}
    >
      <TuModal handleOnSuccess={handleOnSuccess} />
      {children}
    </TuVisibilityContext.Provider>
  );
};

const useTuVisibilityContext = () => useContext(TuVisibilityContext);

export { TuVisibilityProvider, useTuVisibilityContext };
